<template>
  <v-card
    id="taches"
    fluid
  >

  <v-row >

    <v-col cols="6" md="2">
      <v-text-field
        v-model="tmp.mission"
        label="Mission"
        class="required"
      ></v-text-field>
    </v-col>

    <v-col cols="6" md="2">
      <v-text-field
        v-model="tmp.nuit"
        label="nuit"
        type="date"
        class="required"
      ></v-text-field>
    </v-col>

    <v-col cols="6" md="2">
      <v-icon 
      v-if="true"
      small
      color="success"
      class="ma-2"
      @click="Tache_Pistache"
      >mdi-sync
    </v-icon>
    </v-col>
</v-row>

<template>
  <v-data-table
    :headers="headers"
    :items="taches"
    :items-per-page="10"
    class="elevation-1"
  >
  <template v-slot:top>
    <v-toolbar flat>
      <v-toolbar-title></v-toolbar-title>

        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>


        <v-spacer></v-spacer>
                  
        <v-dialog v-model="dialogue_ADD" width="1000">
          <v-card>
            <v-card-title class="headline">


              <v-row >

              <v-col cols="6">
                <v-text-field
                  v-model="tache.name"
                  label="Nom"
                  class="required"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-combobox
                  v-model="tache.type"
                  :items="c_type"
                  label="Type"
                ></v-combobox>

              </v-col>

              <v-col cols="6">
                <v-combobox
                  v-model="tache.cmd"
                  :items="c_cmd"
                  label="CMD"
                ></v-combobox>

              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="tache.l_params"
                  label="Params"
                  class="required"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="tache.comment"
                  label="Comment"
                  class="required"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-combobox
                  v-model="tache.stat"
                  :items="c_stat"
                  label="Etat"
                ></v-combobox>
              </v-col>


              </v-row>


              <v-spacer></v-spacer>

              <v-btn 
                  :loading="v_loading" 
                  color="success" 
                  text
                  :disabled="  !(
                      true
                    )"
                  @click="Save_Tache">Save</v-btn>


              <v-btn color="error" text @click="dialogue_ADD = false">Cancel</v-btn>              

            </v-card-title>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogue_EDIT" width="1000">
          <v-card>
            <v-card-title class="headline">


              <v-row >

              <v-col cols="6">
                <v-text-field
                  v-model="tache.name"
                  label="Nom"
                  class="required"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-combobox
                  v-model="tache.type"
                  :items="c_type"
                  label="Type"
                ></v-combobox>

              </v-col>

              <v-col cols="6">
                <v-combobox
                  v-model="tache.cmd"
                  :items="c_cmd"
                  label="CMD"
                ></v-combobox>

              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="tache.l_params"
                  label="Params"
                  class="required"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="tache.comment"
                  label="Comment"
                  class="required"
                ></v-text-field>
              </v-col>

              <v-col cols="6">

                <v-combobox
                  v-model="tache.stat"
                  :items="c_stat"
                  label="Etat"
                ></v-combobox>
              </v-col>


              </v-row>


              <v-spacer></v-spacer>

              <v-btn 
                  :loading="v_loading" 
                  color="success" 
                  text
                  :disabled="  !(
                      true
                    )"
                  @click="Update_Tache">Save</v-btn>


              <v-btn color="error" text @click="dialogue_EDIT = false">Cancel</v-btn>              

            </v-card-title>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog"
          max-width="500px"
          :retain-focus="false"
        >
          <template  v-slot:activator="{}">

          
            <v-icon
              color="blue darken-3"
              class="ma-2"
              @click="Add_Tache()"
            >mdi-plus-circle     
            </v-icon>

          </template>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:[`item.actions`]="{ item }">


      <v-icon 
        v-if="true"
        small
        color="success"
        class="ma-2"
        @click="Edit_Tache(item)"
        >mdi-pencil
      </v-icon>

      <v-icon
      v-if="true"
        small
        color="error"
        class="ma-2"
        @click="Delete_Tache(item)"
        >mdi-delete
      </v-icon>


      <v-dialog v-model="dialogue_DELETE"
        max-width="1000px"
        style="z-index: 1000"
        :retain-focus="false"
      >
        <v-card flat>
          
          <v-card-title>
            
            <span class="headline" >Do you really want to remove this Task ?
            </span>

          </v-card-title>
          <v-card-actions>

            <v-spacer></v-spacer>

            <v-btn 
              color="success"
              class="ma-2"
              dark
              @click="Close_Tache()"
              >Cancel
            </v-btn>

            <v-btn
              color="error"
              class="ma-2"
              dark
              @click="Delete_ThisTache()"
              >Yes
            </v-btn>
                          
          </v-card-actions>
          
        </v-card>
      </v-dialog>

    </template>

    <template>


    </template>



  </v-data-table>






</template>

</v-card>
</template>
<script>
  

  


  export default {

    data: () =>({

      tmp : {"mission":"L232N01","nuit":"2023-10-12"},

      texte_test :"tête vide",
      dialog : false,

      dialogue_ADD : false,
      dialogue_EDIT : false,
      dialogue_DELETE : false,

      filter :"",
      c_stat : ["NEW","START","RUN","ENCOURS","ANULLATION","DONE","OK","NULL","ERR"],
      c_type : ["DATA","SYS","CONTROL"],
      c_cmd : ["MAKE_RAW_NIGHT_MISS","NOP"],

      headers: [
          { text: 'id', value: 'id' },
          { text: 'Name', value: 'name' },
          { text: 'type', value: 'type' },
          { text: 'CMD', value: 'cmd' },
          { text: 'params', value: 'l_params' },
          { text: 'stat', value: 'stat' },
          { text: 'Actions', value: 'actions' }

        ],
      title : "Taches",
      N_Dernieres : 1,


      data_table_base :{

      },

      tache_base :{
        "id" : -1,
        "ts" : "", 
        "name" : "",
        "type" : "DATA",
        "cmd" :   "NOP",
        "params" : {},
        "l_params" : "{}",
        "comment" : "",
        "stat" : "NEW",
      },
      tache:{
        "id" : -1,
        "ts" : "", 
        "name" : "",
        "type" : "",
        "cmd" :   "",
        "params" : {},
        "l_params" : "{}",
        "comment" : "",
        "stat" : "",
      },
      data_table :[],

      params:"",


      taches:[],
      taches_t:[],

      v_loading : false

    }),
  initialize(){

  },
  created(){
    
  },
  beforeMount(){
     

  },
  mounted(){

    this.Load_Taches_liste();
    this.Set_Taches_liste();
    this.A_Update_Taches = setInterval(() => {
      this.Load_Taches_liste();
      this.Set_Taches_liste();
    },2000);
  },

  methods: {
    Tache_Pistache(){



      
      const othis=this;

      var url = backend_url + "/DATA/NEO/RAWs_PIC/Get_Mission_Nuit/";
      //var data = {"mission":"L232N01","nuit":"2023-10-12"}; 

      this.axios.post(url,this.tmp)
        .then((res) => {
          console.log("retour");
          console.log(res);

          /*this.c_missions = res.data.missions;
          this.fichiers = res.data.res;
          othis.Jatttend_Go = false;*/

        })
        .catch((error) => {
          console.log("err");
          console.error(error);

          //console.log("PB get -> Find_Between");
          //this.loading_ot = false;
          //othis.Jatttend_Go = false;
        });




    },
    Load_Taches_liste(){

      const othis = this;

      this.axios.get( backend_url+ "/Tache",{})
      .then((res) => {

        
          othis.taches_t = JSON.parse(JSON.stringify(res.data));
         // othis.taches_t.t_params = "zouzou";//JSON.stringify(othis.taches_t.params);
          this.taches = JSON.parse(JSON.stringify(othis.taches_t));
      })
      .catch(() => {
        console.log("PB au chargement de la liste des taches");
      });

    },
    Set_Taches_liste(){

      this.taches = JSON.parse(JSON.stringify(this.taches_t));
 
    },  

    Add_Tache(){
      this.tache = JSON.parse(JSON.stringify(this.tache_base));
      this.dialogue_ADD = true;
      this.dialogue_EDIT = false;
      this.dialogue_DELETE = false
    },
    Close_Tache(){
      dialogue_ADD = false;
      dialogue_EDIT = false;
      dialogue_DELETE = false;
    },

    Delete_Tache(item){

      this.tache= item;
      this.dialogue_DELETE = true;

    },
    Edit_Tache(item){

      this.tache = item;
      this.params = JSON.stringify(this.tache.params);
      this.dialogue_EDIT= true;

    },
    Delete_ThisTache(){

      const othis = this;

      this.axios.delete( backend_url +"/Tache/delete/"+othis.tache.id,{})
      .then((res) => {

          othis.taches_t = JSON.parse(JSON.stringify(res.data));
          this.taches = JSON.parse(JSON.stringify(othis.taches_t));
          //this.taches.t_params = "zouzou";//JSON.stringify(othis.taches_t.params);

          this.dialogue_DELETE = false;
      })
      .catch(() => {
        console.log("PB  suppréssion d'une taches");
        this.dialogue_DELETE = false;
      });
      
    },

    Save_Tache(){

      const othis = this;

      this.tache.params = JSON.parse(this.tache.l_params);

      this.axios.post( backend_url+"/Tache/creat",this.tache)
      .then((res) => {
          console.log(res.data);
          othis.taches_t = JSON.parse(JSON.stringify(res.data));
          //othis.taches_t.t_params = "zouzou";//JSON.stringify(othis.taches_t.params);
          this.taches = JSON.parse(JSON.stringify(othis.taches_t));
          

          this.dialogue_ADD = false;
      })
      .catch(() => {
        console.log("PB soumission d une nouvelle Tache");
        this.dialogue_ADD = false;
      });

      

    },
    Update_Tache(){

     const othis = this;
     this.tache.params = JSON.parse(this.tache.l_params);

     this.axios.put( backend_url + "/Tache/"+this.tache.id,this.tache)
      .then((res) => {

          othis.taches_t = JSON.parse(JSON.stringify(res.data));
          this.taches = JSON.parse(JSON.stringify(othis.taches_t));
          //this.taches.params = JSON.stringify(othis.taches_t.params);

          this.dialogue_EDIT = false;
      })
      .catch((error) => {
        console.log(error);
        console.log("PB soumission d une Tache");
        this.dialogue_EDIT = false;
      });

    }

  }
}
</script>